interface ErrorMessageProps {
    error?: {
        message?: any;
    };
}

const ErrorMessage = (props?: ErrorMessageProps) => {
    return (
        <label className="error">{props?.error?.message}</label>
    );
};

export default ErrorMessage;